import React from 'react'
// import {BrowserRouter, Route, Switch, NavLink} from 'react-router-dom';
import 'normalize.css'
import './assets/home.sass'
import logo from './assets/logo-white.svg'

function App() {

  const script = document.createElement('script')
  script.src = (process.env.REACT_APP_WIDGET_URL && process.env.REACT_APP_WIDGET_URL.length > 0)
    ? process.env.REACT_APP_WIDGET_URL
    : 'https://cdn.theaccessplatform.com/widget.js'
  script.defer = true
  document.body.appendChild(script)

  return (
    <div className="App">
      <header>
        <div className="logo-link">
          <img src={logo} className="logo" alt="Sutton Trust"/>
        </div>
        <div className="banner">
          <h1>Chat to us</h1>
        </div>
      </header>
      <div className="wrapper">
        <iframe
          title='Sutton Trust TAP Page'
          id='tap-iframe-widget'
          src=''
          width='100%'
          height='700'
          scrolling='no'
          data-type='full-widget'
          data-group-id='2'
          />
      </div>
    </div>
  );
}

export default App;
